// extracted by mini-css-extract-plugin
export default {"container":"NamedCheckbox_container__ax3bX"};